var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "messageCon"
  }, [_c('div', {
    staticClass: "userInfo"
  }, [_c('div', {
    staticClass: "userInfo_left",
    on: {
      "click": function ($event) {
        return _vm.goUserPage(_vm.messagereply.memberId);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.messagereply.memberAvatar,
      "alt": ""
    },
    on: {
      "error": function ($event) {
        return _vm.defImg();
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.messagereply.isOfficial == 1 || _vm.messagereply.isOfficial == 2 || _vm.messagereply.isOfficial == 3 || _vm.messagereply.memberAuthInfo,
      expression: "\n            messagereply.isOfficial == 1 ||\n            messagereply.isOfficial == 2 ||\n            messagereply.isOfficial == 3 ||\n            messagereply.memberAuthInfo\n          "
    }],
    staticClass: "message_leftbox_img_icon",
    class: _vm.messagereply.memberAuthInfo && _vm.messagereply.isOfficial == 0 ? 'memberAuthInfoFlag' : ''
  }), _c('div', {
    staticClass: "messageCon_userbox",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goUserPage(_vm.messagereply.memberId);
      }
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_c('div', [_vm._v(_vm._s(_vm.messagereply.memberNickName))]), _c('levelIcon', {
    attrs: {
      "level": _vm.messagereply.memberExpLevel
    }
  }), _vm.messagereply.memberAuthInfo && _vm.messagereply.isOfficial != 1 && _vm.$store.state.gameType != 2 ? _c('div', {
    staticClass: "auth_icon"
  }, [_vm._v(" " + _vm._s(_vm.messagereply.memberAuthInfo) + " ")]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.messagereply.memberId == _vm.messagereply.postsPosterId,
      expression: "messagereply.memberId == messagereply.postsPosterId"
    }],
    staticClass: "messageCon_poster"
  }, [_vm._v(" 楼主 ")])], 1), _c('p', {
    staticClass: "message_floor",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.replyUser(_vm.messagereply, 'poster');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.messagereply.floorNum) + "楼 ")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.sharePage,
      expression: "!sharePage"
    }],
    staticClass: "details_comments_top_extension",
    on: {
      "click": function ($event) {
        return _vm.vanActionFlag(_vm.messagereply);
      }
    }
  }, [_vm._v(" ... ")])]), _c('div', {
    staticClass: "messageCon_content",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.replyUser(_vm.messagereply, 'poster');
      }
    }
  }, [_c('p', {
    staticClass: "msg",
    domProps: {
      "innerHTML": _vm._s(_vm.messagereply.content)
    }
  }), _vm.messagereply.pictures ? _c('div', {
    staticClass: "msgReplyImg"
  }, [_c('img', {
    attrs: {
      "preview": _vm.messagereply.pictures[0].path + _vm.imgThumb,
      "src": _vm.messagereply.pictures[0].path + _vm.imgThumb,
      "alt": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.imgClick.apply(null, arguments);
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "messageCon_bottom"
  }, [_c('p', {
    staticClass: "msgTime"
  }, [_vm._v(_vm._s(_vm.messagereply.createTime))]), _c('div', {
    staticClass: "messageCon_bottom_iconbox"
  }, [_c('div', {
    staticClass: "likeWrap level1",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.lickClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    ref: "level1_lickbtn",
    staticClass: "card_lickbtn",
    class: _vm.messagereply.isLike ? 'publicAction_curgoodicon' : 'publicAction_goodicon'
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.messagereply.likeNum != 0,
      expression: "messagereply.likeNum != 0"
    }],
    staticClass: "level1_licknum"
  }, [_vm._v(" " + _vm._s(_vm.messagereply.likeNum) + " ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.sharePage,
      expression: "!sharePage"
    }],
    staticClass: "stepWrap",
    class: _vm.messagereply.isBad ? 'onstepWrap' : '',
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.badClick.apply(null, arguments);
      }
    }
  }, [_c('p')]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.sharePage,
      expression: "!sharePage"
    }],
    staticClass: "commentsWrap",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.replyUser(_vm.messagereply, 'poster');
      }
    }
  }, [_c('p'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.messagereply.replyNum > 0,
      expression: "messagereply.replyNum > 0"
    }],
    class: _vm.messagereply.replyNum ? 'on' : ''
  }, [_vm._v(_vm._s(_vm.messagereply.replyNum))])])])])])]), _vm.replyCommentList ? _c('div', _vm._l(_vm.replyCommentList, function (item) {
    return _c('messagereply', {
      key: item.id,
      attrs: {
        "commentListReplyData": item,
        "sharePage": _vm.sharePage
      },
      on: {
        "vanActionFlag": _vm.vanActionFlag,
        "goUserPage": _vm.goUserPage,
        "replyUser": _vm.replyUser
      }
    });
  }), 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.messagereply.replyNum > 2 && _vm.messagereplyFlag && !_vm.sharePage,
      expression: "messagereply.replyNum > 2 && messagereplyFlag && !sharePage"
    }],
    staticClass: "message_allbtn",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goAllReply.apply(null, arguments);
      }
    }
  }, [_vm._v(" 展开" + _vm._s(_vm.messagereply.replyNum - 2) + "条回复 ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };